/**
 * MODULE: _shared/frontend-shell/src/features/crm/data/opportunityDrawerOptions.ts
 * PURPOSE: Select options for OpportunityDrawer (mock-backed, Prompt 4-A)
 * DEPENDENCIES: ../types/opportunity.types, ./scheduleModalCatalog
 * PUBLIC_API: OPPORTUNITY_STAGE_OPTIONS, OPPORTUNITY_TERRITORY_OPTIONS, OPPORTUNITY_OWNER_OPTIONS, DEAL_LOST_REASON_OPTIONS
 * SIDE_EFFECTS: None
 * AGENT_SAFETY: SAFE
 * RECENT: 2026-05-08 [2.2.882] JSDoc for **`DEAL_LOST_REASON_OPTIONS`** aligned with **`DealStageProgress`** — root **`CHANGELOG` [2.2.882]`**
 */

import { CRM_DEAL_STAGE_LABELS, CRM_FUNNEL_STAGE_ORDER } from '../constants/crmDealStages';
import type { OpportunityStage } from '../types/opportunity.types';
import { MOCK_SCHEDULE_OWNERS } from './scheduleModalCatalog';

export const OPPORTUNITY_STAGE_OPTIONS: { value: string; label: string }[] = CRM_FUNNEL_STAGE_ORDER.map(
  (value: OpportunityStage) => ({ value, label: CRM_DEAL_STAGE_LABELS[value] })
);

/** Mock territories aligned with MOCK_CRM_OPPORTUNITIES territoryId values. */
export const OPPORTUNITY_TERRITORY_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: 'None' },
  { value: 'terr-west', label: 'West' },
  { value: 'terr-mw', label: 'Midwest' },
  { value: 'terr-east', label: 'East' },
];

export const OPPORTUNITY_OWNER_OPTIONS: { value: string; label: string }[] = MOCK_SCHEDULE_OWNERS.map((o) => ({
  value: o.id,
  label: o.name,
}));

/** Required when marking a deal **closed_lost** from **`DealStageProgress`** (stored as **`lost_reason`**). */
export const DEAL_LOST_REASON_OPTIONS: { value: string; label: string }[] = [
  { value: 'competitor_won', label: 'Lost to competitor' },
  { value: 'no_budget', label: 'No budget' },
  { value: 'no_decision', label: 'No decision / stalled' },
  { value: 'timing', label: 'Bad timing' },
  { value: 'unqualified', label: 'Unqualified / poor fit' },
  { value: 'other', label: 'Other' },
];
